/**
 * ============================================================================
 *  APP · CMS BINDING — done once, for the whole application.
 * ============================================================================
 *
 *  The framework is generic. This is the single line that tells it about OUR
 *  sections, after which everything downstream is fully typed:
 *
 *      cms.get(SectionName.Hero).data     // → HeroSection | null
 *      <SectionUpdate name={SectionName.Hero}>{(hero) => …}</SectionUpdate>
 *
 *  Import `cms` and `SectionUpdate` from here — never from @framework/react.
 */
import { createCms } from '@framework/react';
import type { SectionTypes } from '@app/sections';

export const { cms, SectionUpdate } = createCms<SectionTypes>();
